import kitchenInstance from '../instance'

const getKitchenMonitorConfigs = () => {
	return kitchenInstance.get('/kitchenMonitorConfigs')
}

export default getKitchenMonitorConfigs
